import { v4, v7 } from 'uuid';

import { UUID } from '@/types';

const SESSION_ID_KEY = 'session_id';

export const resolveSessionId = (): UUID | null => {
  if (typeof window === 'undefined') return null;

  const existing = window.sessionStorage.getItem(SESSION_ID_KEY);
  if (existing) return existing as UUID;

  const next = v4() as UUID;
  window.sessionStorage.setItem(SESSION_ID_KEY, next);

  return next;
};

export const generateStreamId = (): UUID => v7() as UUID;
